import Styled from "styled-components";

export default Styled.div`
    div.modal-container {
        width: 40rem;
        max-width: 95vw;
        form {
            padding: 1.5em 2em;
            margin: 0 auto;
            max-height: 75vh;
            overflow-y: auto;
            ${({ theme }) => theme.mixins.scrollbar};
            width: 100%;
            label {
                color: #555;
                font-weight: 500;
                font-size: 0.85rem;
                margin-bottom: 4px;
                display: block;
            }
            .form-section-title {
                font-size: 0.95rem;
                font-weight: 700;
                color: #2c3e50;
                margin: 18px 0 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                border-bottom: 1px solid #edf2f7;
                padding-bottom: 4px;
            }
            .form-grid-2 {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 12px;
            }
            .form-grid-3 {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                gap: 12px;
            }
            select, input {
                width: 100%;
                border-radius: 4px;
                border: 1px solid #d9d9d9;
                padding: 8px 12px;
                font-size: 0.9rem;
                transition: border-color 0.2s;
                &:focus {
                    border-color: #40a9ff;
                    outline: none;
                }
            }

            div.img-container {
                margin: 0.5em 0 1.25em;
                text-align: center;

                label.upload-label {
                    min-height: 8.5rem;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 2px dashed ${({ theme }) => theme.primary || "#3498db"};
                    cursor: pointer;
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    position: relative;
                    overflow: hidden;
                    background-color: #f8fafc;
                    transition: border-color 0.2s, background-color 0.2s;

                    &:hover {
                        border-color: #2980b9;
                        background-color: #f1f5f9;
                    }

                    .upload-content {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 10px 18px;
                        border-radius: 6px;
                        background: rgba(255, 255, 255, 0.9);
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

                        svg {
                            font-size: 2rem;
                            color: ${({ theme }) => theme.primary || "#3498db"};
                            margin-bottom: 4px;
                        }
                        p {
                            font-size: 0.85rem;
                            color: #333;
                            margin: 2px 0 0;
                            font-weight: 600;
                        }
                        span.sub-text {
                            font-size: 0.75rem;
                            color: #777;
                        }
                    }

                    input[type="file"] {
                        display: none;
                    }
                }

                .img-actions {
                    margin-top: 6px;
                    display: flex;
                    justify-content: center;

                    .remove-img-btn {
                        background: none;
                        border: none;
                        color: #e74c3c;
                        font-size: 0.8rem;
                        cursor: pointer;
                        padding: 2px 8px;
                        border-radius: 4px;
                        transition: background-color 0.2s;

                        &:hover {
                            background-color: #fde8e8;
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

        div.loading-container {
            padding: 4em;
        }
    }
`;
